import { useTranslation } from '@/ui/hooks';
import { DataTable } from '@juvare/common-data-table-ui/DataTable';
import { PageHeaderWithImage } from '@juvare/common-web-ui/PageHeader';
import AddIcon from '@mui/icons-material/Add';
import { Box } from '@mui/material';
import React from 'react';
import { ReloadUsersTableContext } from '../contexts/ReloadUsersTableContext';
import { useHandleAddUser } from '../hooks/useHandleAddUser';
import { useUserTable } from '../hooks/useUserTable';

export const UserManagementPage: React.FC = ({}) => {
    const { t } = useTranslation();
    const { dataTableProps, reload } = useUserTable();
    const handleAddUser = useHandleAddUser(reload);
    return (
        <>
            <PageHeaderWithImage gradient='blue-base' title={t('users')} />
            <Box sx={{ p: 4 }}>
                <ReloadUsersTableContext.Provider value={reload}>
                    <DataTable {...dataTableProps} mainAction={{ label: t('add'), icon: <AddIcon />, onClick: handleAddUser }} />
                </ReloadUsersTableContext.Provider>
            </Box>
        </>
    );
};
